import { defineComponent as _defineComponent } from 'vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import Vue, { nextTick, onMounted, ref, watch } from 'vue';
    import { useSemiLoginStore } from '@/store/semilogin';
    import { useCustomerStore } from '@/store/customer';
    import { getURLFromWebsite } from '@/util/urls';
    import router from '@/router';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SemiLoginModal',
  props: {
    open: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
        open: boolean;
    }

    

    const { customer } = useCustomerStore();
    const semiLoginStore = useSemiLoginStore();
    const customerStore = useCustomerStore();

    /** Tabs */
    const activeTab = ref(0);

    watch(activeTab, (val) => {
        if (val === 1) {
            customer.is_company = true;
        } else {
            customer.is_company = false;
        }
    });

    /** Modal */
    const modalActive = ref(false);
    const initialCompanyState = ref(false);

    watch(
        () => props.open,
        async (value) => {
            modalActive.value = value;
            email.value = '';
            if (value) {
                // Save inital company state so it can be reverted wenn canceled
                if (customer.is_company !== undefined)
                    initialCompanyState.value = customer.is_company;

                if (customer.is_company) activeTab.value = 1;
                else activeTab.value = 0;

                //Clear sales channel because of edge case of old IDs
                customer.sales_channel = undefined;

                //init Google login
                await semiLoginStore.loadObjects();
                semiLoginStore.checkStateExpiration();
                await nextTick();
                semiLoginStore.initGoogle();
            }
        },
    );

    const email = ref<string>('');

    function customMailMode() {
        return {
            on: ['input'],
        };
    }

    function closeModal() {
        customer.is_company = initialCompanyState.value;
        semiLoginStore.state.logoutRequested = false;
        email.value = '';

        if (!semiLoginStore.state.loggedIn) {
            router.push({ name: 'selector' });
        }

        Vue.prototype.$posthog.capture('User hat Login Modal geschlossen');
    }

    /** Form Submit */
    function onSubmit() {
        doSemiLogin();
    }

    /**
     * Do the login: unlock the configurator.
     */
    async function doSemiLogin() {
        semiLoginStore.unlockConfigurator(email.value);
        await customerStore.dispatchCustomerAddOrUpdate();
        Vue.prototype.$posthog.capture('User hat sich eingeloggt');
        semiLoginStore.state.logoutRequested = false;
    }

    /** watch Google Login, if true login immediately */
    // Dont use this logic anymore because Tel Nr is required
    // watch(
    //     () => semiLoginStore.isSSOLoggedIn,
    //     (val) => {
    //         if (val) doSemiLogin();
    //     },
    // );

    onMounted(async () => {
        // reset open when logout when page reload
        semiLoginStore.state.logoutRequested = false;
        // get inital open value
        modalActive.value = props.open;
        //init Google login
        await semiLoginStore.loadObjects();
        semiLoginStore.checkStateExpiration();
        await nextTick();
        semiLoginStore.initGoogle();
    });

return { __sfc: true,props, customer, semiLoginStore, customerStore, activeTab, modalActive, initialCompanyState, email, customMailMode, closeModal, onSubmit, doSemiLogin, ValidationObserver, ValidationProvider, getURLFromWebsite }
}

})